'use client';

import clsx from 'clsx';
import { CopyIcon } from 'lucide-react';

import { useAdmin } from '@/app/providers';
import { Button } from '@/components/ui/button';

type Participants = {
  name: string;
  birth_country: {
    id: string;
    emoji: string | null;
    translations: ({ name: string } | null)[] | null;
  } | null;
}[];

export function ParticipantListCopy({
  participants,
  isInternational,
  mainCountryId,
  className,
}: {
  participants: Participants;
  isInternational?: boolean;
  mainCountryId?: string;
  className?: string;
}) {
  const isAdmin = useAdmin();

  if (isAdmin !== true) {
    return;
  }

  return (
    <Button
      variant="outline"
      size="icon"
      className={clsx('size-6 cursor-pointer', className)}
      onClick={() => {
        const text = participants
          .map((participant) => {
            if (
              participant.birth_country &&
              (isInternational ||
                mainCountryId !== participant.birth_country.id)
            ) {
              return `${participant.name} ${participant.birth_country.emoji}`;
            }

            return participant.name;
          })
          .join('\n');

        navigator.clipboard.writeText(text);
      }}
    >
      <CopyIcon className="size-3" />
    </Button>
  );
}
